module.exports = __webpack_public_path__ + "assets/img/desc.b49df658.png";